import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/userprofile.png'


const _withScopeId = n => (_pushScopeId("data-v-7e39da64"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "whole-employee"
}
const _hoisted_2 = { class: "employee-details" }
const _hoisted_3 = { class: "profile-header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Employee Photo",
  class: "profile-photo"
}, null, -1))
const _hoisted_5 = { class: "profile-info" }
const _hoisted_6 = {
  class: "last-login",
  style: {"font-weight":"bold","margin":"2px"}
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_8 = {
  class: "profile-details",
  style: {"font-size":"large"}
}
const _hoisted_9 = { class: "row py-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Employee Id:")
], -1))
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "row py-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Email:")
], -1))
const _hoisted_14 = { class: "col" }
const _hoisted_15 = { class: "row py-2" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Username:")
], -1))
const _hoisted_17 = { class: "col" }
const _hoisted_18 = {
  key: 0,
  class: "row py-2"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Hourly Pay:")
], -1))
const _hoisted_20 = { class: "col" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "$", -1))
const _hoisted_22 = { class: "row py-2" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Work Center:")
], -1))
const _hoisted_24 = { class: "col" }
const _hoisted_25 = { class: "row py-2" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col col-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Date of Joining:")
], -1))
const _hoisted_27 = { class: "col" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = {
  key: 1,
  class: "loading-container"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_36 = [
  _hoisted_35
]

import TaskList from "@/components/TaskList.vue";
import DateTimeBadge from "@/components/DateTimeBadge.vue";
import { useEmployeeStore } from '@/stores/UserEmployee';
import { useTaskStore } from '@/stores/Tasks';
import { storeToRefs } from "pinia";
import { onMounted, computed, ref } from "vue";
import { useRoute, useRouter } from 'vue-router';
import { UserEmployee, WorkCenter } from '@/types/Ops';

interface EmployeeDetail extends UserEmployee {
  work_centers?: WorkCenter[];
}



export default /*#__PURE__*/_defineComponent({
  __name: 'EmployeeDetail',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const employeeStore = useEmployeeStore();
const taskStore = useTaskStore();

const { userRole, currentUser, getById } = storeToRefs(employeeStore);
const { all_tasks, isLoadingTaks } = storeToRefs(taskStore);

const employeeData = ref<EmployeeDetail | null>(null);

const navigateToUserView = (userEmployeeId) => {
  router.push({ name: 'edit-employeeDetails', params: { userEmployeeId } });
};

const fetchEmployeeData = async () => {
  const userEmployeeId = Number(route.params.userEmployeeId);
  try {
    const userEmployee = getById.value(userEmployeeId);
    if (userEmployee) {
      employeeData.value = userEmployee;
    } else {
      console.error('UserEmployee not found');
    }
  } catch (error) {
    console.error('Error fetching UserEmployee data:', error);
  }
};


const filteredTasksForUser = computed(() => {
  if (!employeeData.value || !all_tasks.value || all_tasks.value.length === 0) {
    return [];
  }
  return all_tasks.value.filter(task =>
    task.assignments && task.assignments.some(assignment => assignment.user === employeeData.value.id)
  );
});


onMounted(async () => {
  const userEmployeeId = Number(route.params.userEmployeeId);
  if (!userEmployeeId) {
    // Handle invalid user ID case
    console.error('Invalid User ID');
    return;
  }
  try {
    await employeeStore.fetch();
    const employee = getById.value(userEmployeeId);
    if (employee) {
      employeeData.value = employee;
      await taskStore.getAllTasks();
    } else {
      console.error('Employee not found');
    }
  } catch (error) {
    console.error('Error fetching employee data:', error);
  }
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (employeeData.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("h1", null, [
                _createTextVNode(_toDisplayString(employeeData.value.user?.full_name) + " ", 1),
                _createElementVNode("span", {
                  class: "edit-symbol",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (navigateToUserView(employeeData.value.id)))
                }, "✎")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("p", _hoisted_6, [
                  _createTextVNode("Last Login: "),
                  _createVNode(DateTimeBadge, {
                    time: employeeData.value.user?.last_login
                  }, null, 8, ["time"])
                ])
              ]),
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("div", _hoisted_11, _toDisplayString(employeeData.value.id), 1)
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("div", _hoisted_14, _toDisplayString(employeeData.value.user?.email), 1)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("div", _hoisted_17, _toDisplayString(employeeData.value.user?.username), 1)
                ]),
                (_unref(employeeStore).currentUser.user?.is_superuser)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createTextVNode(" " + _toDisplayString(employeeData.value.hourly_pay), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createElementVNode("div", _hoisted_24, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(employeeData.value.work_centers, (workCenter) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: workCenter.id
                      }, _toDisplayString(workCenter.name), 1))
                    }), 128))
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("div", _hoisted_27, [
                    _createVNode(DateTimeBadge, {
                      time: employeeData.value.user?.date_joined
                    }, null, 8, ["time"])
                  ])
                ])
              ])
            ])
          ]),
          (_unref(isLoadingTaks))
            ? (_openBlock(), _createElementBlock("div", _hoisted_28, " Loading Tasks... "))
            : (filteredTasksForUser.value && filteredTasksForUser.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  (_unref(employeeStore).currentUser.user?.is_superuser)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                        _createVNode(TaskList, {
                          tasks: filteredTasksForUser.value,
                          visibleColumns: ['id', 'name', 'description', 'job_name', 'started', 'concluded', 'total_active_duration', 'labor_cost', 'assigned', 'actions']
                        }, null, 8, ["tasks"])
                      ]))
                    : _createCommentVNode("", true),
                  (_unref(employeeStore).currentUser.user?.is_staff && !_unref(employeeStore).currentUser.user?.is_superuser)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createVNode(TaskList, {
                          tasks: filteredTasksForUser.value,
                          visibleColumns: ['id', 'name', 'description', 'job_name', 'started', 'concluded', 'total_active_duration', 'assigned', 'actions']
                        }, null, 8, ["tasks"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_32, " No tasks to display. ")),
          _hoisted_33,
          _createElementVNode("div", null, [
            _createVNode(_component_router_link, {
              to: "/ops/allusers",
              class: "apple-button"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Back to User List")
              ]),
              _: 1
            })
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_34, _hoisted_36))
}
}

})